export default __webpack_public_path__ + "static/media/jednostavno_p.e4a61825.png";